import {apiPost,apiGet} from "./apiUtils";
import { getLoggedInUserTenantID } from "./sessionUtil";

var processes = 
[
 "Default"
]
;

export function getProcesses() {
      
    let tenantId = getLoggedInUserTenantID();
    let url = `${process.env.REACT_APP_API_PREFIX}/process/getProcessesByTenantId/${tenantId}`;
    return apiGet(url);
 
 }


 export async function addProcess(proc){
    console.log("Adding process "+JSON.stringify(proc));
    let url = `${process.env.REACT_APP_API_PREFIX}/process/createProcess`;
    proc.tenantId = getLoggedInUserTenantID();
    return apiPost(url,proc);    
 }

 export function updateProcess(proc){

    proc.tenantId = getLoggedInUserTenantID();
    let url = `${process.env.REACT_APP_API_PREFIX}/process/updateProcess`;
    return apiPost(url,proc);
 }

 export function deleteProcess(proc){
    console.log("Deleting process " + JSON.stringify(proc))
    proc.tenantId = getLoggedInUserTenantID();
    let url = `${process.env.REACT_APP_API_PREFIX}/process/deleteProcess`;
    return apiPost(url,proc);

 }

 
 


 